import axiosInstance from "../axiosInstance";

export const crearPostventa = async (adminId, data) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/postventa-crearPostventa`,
    {
      adminId,
      ...data,
    }
  );
};
